
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import Predictions from './components/Predictions';
import LoginLayout from './components/layout/LoginLayout';
import About from './components/About';
import { AppRoutes } from './axios/endPoints';
import { ProtectedRouting } from './components/routing/ProtectedRouting';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import PredictionResults from './components/PredictionResults';
import UserManagement from './components/user-managment/user-managment';
import { Roles } from './components/layout/menu-items';
import Trainer from './components/usep-trainer/Trainer';
import useNotifications from './components/notifications/notifier';
import { useEffect } from 'react';
import { RootState, useAppDispatch, useAppSelector } from './store/store';
import { getLanguages } from './store/app-slice/app';
import AxiosHandler from './axios/axiosHandler';

function App() {
  const dispatch = useAppDispatch();
  const { languages } = useAppSelector((state: RootState) => state.app);  
  useNotifications();
  useEffect(() => {
    if (languages.length === 0) {
      dispatch(getLanguages());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Routes>
      <Route path={AppRoutes.LOG_IN} element={<LoginLayout><Login/></LoginLayout>}/>
      <Route path={AppRoutes.FORGOT_PASSWORD} element={<LoginLayout><ForgotPassword/></LoginLayout>}/>
      <Route path={AppRoutes.RESET_PASSWORD} element={<LoginLayout><ResetPassword /></LoginLayout>} />
      
      <Route 
        path={AppRoutes.ABOUT} 
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.USEPAdmin, Roles.USEPUser]}>
            <About />
          </ProtectedRouting>
        }
      />

      <Route 
        path={AppRoutes.PREDICTIONS} 
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.USEPAdmin, Roles.USEPUser]}>
            <Predictions/>
          </ProtectedRouting>
        }
      />
      <Route 
        path={AppRoutes.PREDICTION_RESULTS} 
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.USEPAdmin, Roles.USEPUser]}>
            <PredictionResults/>
          </ProtectedRouting>
        }
      />
      <Route 
        path={AppRoutes.MODEL_TRAINING} 
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.USEPAdmin]}>
            <Trainer/>
          </ProtectedRouting>
        }
      />
      <Route 
        path={AppRoutes.USER_MANAGEMENT} 
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.USEPAdmin]}>
            <UserManagement/>
          </ProtectedRouting>
        }
      />
    </Routes>
  );  
}

export default AxiosHandler(App);
